import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import './ErrorField.scss';

const ErrorField = ({ element = '', className }) => {
	return <div className={classNames('ErrorField', className)}>{element}</div>;
};

ErrorField.propTypes = {
	element: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	className: PropTypes.string,
};

export default ErrorField;
